import {texture, MiniSignal, performNextTick} from "p3";
import GameScene from "../../scenes/GameScene";
import definitions from "../../definitions";
import common from "../../common";
import Actor from "./Actor";

export default class ActorPipeHorizontal extends Actor {
    constructor() {
        super(definitions.ACTOR_ID.PIPE_ENTRANCE_HORIZONTAL);

        this.signals.travel = new MiniSignal();

        this.collisionRadius = 24;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -34;

        this.interactable = true;
        this.interactionRadius = 70;
    }

    init() {
        super.init();

        this.signals.travel.once(this._onEnter, this);

        this._setPipeTexture();
    }

    update() {
        super.update();
        
        const d = new P3.Vector2(this.x - GameScene.active.player.x, this.y - GameScene.active.player.y);
        if (d.length < this.interactionRadius) {
            performNextTick(() => this.signals.travel.dispatch());
        }
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
    }

    _onEnter() {
        GameScene.active.useLevelShortcut(this.uid);
    }

    _setPipeTexture() {
        const activeLocation = GameScene.active.loadedLevel;
        let locationSuffix = activeLocation[0] + activeLocation.substring(activeLocation.indexOf('_') + 1)[0];
        if (locationSuffix === "sl") {
            locationSuffix = "sv";
        }
        this.addViewWithTexture(texture(locationSuffix.concat("_d_sewer_exit_00")));
    }
}